import * as React from "react";
const SvgMail = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={12}
    fill="none"
    {...props}
  >
    <path
      stroke="#89909D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M9.5 3.8 7.622 5.3c-.618.492-1.632.492-2.25 0L3.5 3.8m6 6.9h-6c-1.8 0-3-.9-3-3V3.5c0-2.1 1.2-3 3-3h6c1.8 0 3 .9 3 3v4.2c0 2.1-1.2 3-3 3"
    />
  </svg>
);
export default SvgMail;
